export default function () {
  return {
    cartID: null,
    cartContent: null,
    countries: null
  };
}
